import * as PIXI from 'pixi.js';
import { map as mapSetup } from 'setup';
import { createGrid, getUrl } from './common';

export function createCell(x?: number, y?: number) {
    return new PIXI.Point(x, y);
}

export function getCell(point: PIXI.Point) {
    const cell = point.clone();
    cell.x = Math.round(cell.x / mapSetup.cells.size);
    cell.y = Math.round(cell.y / mapSetup.cells.size);
    return cell;
}

export function getCellPosition(cell: PIXI.Point) {
    const position = cell.clone();
    position.x *= mapSetup.cells.size;
    position.y *= mapSetup.cells.size;
    return position;
}

export function getBetweenCell(cell1: PIXI.Point, cell2: PIXI.Point) {
    const cell = cell1.clone();
    cell.x += Math.floor((cell2.x - cell1.x) / 2);
    cell.y += Math.floor((cell2.y - cell1.y) / 2);
    return cell;
}

export async function getTexture(path: string): Promise<PIXI.Texture> {
    // Pixi v8 no longer loads textures from a URL synchronously via
    // Texture.from(); resources are loaded through the Assets system, which
    // resolves once the underlying source is ready and caches by URL.
    const url = getUrl(`/assets/${path}`);
    try {
        return await PIXI.Assets.load<PIXI.Texture>(url);
    } catch (e) {
        throw new Error(`Failed to load texture: ${path}`);
    }
}

export async function getTextures(paths: string[]): Promise<PIXI.Texture[]> {
    const promises = paths.map(getTexture);
    return Promise.all(promises);
}

export function isInBounds(point: PIXI.Point, bounds: PIXI.Rectangle) {
    return point.x >= bounds.left && point.x <= bounds.right && point.y >= bounds.top && point.y <= bounds.bottom;
}

export function traverseFog(mapping: (x: number, y: number) => any) {
    createGrid(mapSetup.cells.wide, mapSetup.cells.wide, 0)
        .forEach((row, x) => {
            row.forEach((_column, y) => {
                if (x < mapSetup.startArea.x || x >= mapSetup.startArea.x + mapSetup.startArea.width || y < mapSetup.startArea.y || y >= mapSetup.startArea.y + mapSetup.startArea.height) {
                    mapping(x, y);
                }
            });
        });
}

export function traverseGrid(wide: number, high: number, mapping: (x: number, y: number) => any) {
    createGrid(wide, high, 0)
        .forEach((row, x) => {
            row.forEach((_column, y) => mapping(x, y));
        });
}